module.exports = "<div></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/callback/callback.component.html
// module id = ./src/app/callback/callback.component.html
// module chunks = main